import React from 'react';
const Comment = (props) => {

  return (
    <div className="comments p-3 card-color">
      {props.type === 'input' && (
        <input
          name="comment"
          onChange={props.onChange}
          value={props.value}
          onBlur={props.onBlur}
          className={`card-color card-subtitle-color`}
          placeholder="Add special instructions"
        />
      )}

      {props.type === 'textarea' && (
        <textarea
          className={`form-control card-color card-subtitle-color`}
          rows={5}
          name="comment"
          onChange={props.onChange}
          value={props.value}
          autoFocus={true}
          placeholder="Add special instructions"
        />
      )}
    </div>
  );
};

export default Comment;
